export default __webpack_public_path__ + "static/media/snake.52d8b576.ogg";